import axios from "axios";
// const client = axios.create({ baseURL: process.env.APP_SERVICE_ENDPOINT });
const client = axios.create({ baseURL: "https://api.cliffex.co.uk/api" });
//const client = axios.create({ baseURL: "https://localhost:4300/api" });
// get the users auth token if exists
if(localStorage.getItem('cliffex-auth-token') != null)
{
    client.defaults.headers.common['X-cliffex-auth'] = '' + localStorage.getItem('cliffex-auth-token');
}

export const httpClient = client;